<template>
	<div>
		<Navbar></Navbar>
		
		<Loader :show="loading"></Loader>
		<div class="main-content">

			<div class="container mt-3" v-if="!loading">
				<div class="row">
					<div class="col mb-4">
						<div class="d-flex justify-content-between align-items-center">
							<h3>Dashboard</h3>
							<b-dropdown :text="selectedClient || 'Todos'" right  class="btn-text m-md-2">
								<b-dropdown-item @click="filterByClient(null)">Todos</b-dropdown-item>
								<b-dropdown-item v-for="item of clients" :key="item.id" @click="filterByClient(item)">
									{{item.name}}
								</b-dropdown-item>
							</b-dropdown>
						</div>
					</div>
				</div>
				<div class="row mb-3">
					<div class="col-12 col-md-7">
						<div class="boxes">
							<div @click="carsListFiltered('PRE_ADMITTED')" class="box">
								<div class="number">{{data.totals.carsPreAdmited}}</div>
								<div class="label">Pre admitidos</div>
							</div>
							<div @click="carsListFiltered('CUSTOMS_DISPATCH_PENDING')" class="box">
								<div class="number">{{data.totals.carsCustomsDispatchPending}}</div>
								<div class="label">En fiscal sin despachar</div>
							</div>
							<div @click="carsListFiltered('CUSTOMS_DISPATCHED')" class="box">
								<div class="number">{{data.totals.carsCustomsDispatched}}</div>
								<div class="label">Recien despachados</div>
							</div>
							<div @click="carsListFiltered('PRE_DELIVERY_PENDING')" class="box">
								<div class="number">{{data.totals.carsPreDeliveryPending}}</div>
								<div class="label">Pendientes de pre entrega</div>
							</div>
							<div @click="carsListFiltered('PRE_DELIVERY_DONE')" class="box">
								<div class="number">{{data.totals.carsPreDeliveryDone}}</div>
								<div class="label">Pre entegas realizadas</div>
							</div>
							<div @click="carsListFiltered('DELIVERY_REQUESTED')" class="box">
								<div class="number">{{data.totals.carsDeliveryRequested}}</div>
								<div class="label">Entregas solicitadas</div>
							</div>
							<div @click="carsListFiltered('DELIVERY_SCHEDULED')" class="box">
								<div class="number">{{data.totals.carsDeliveryScheduled}}</div>
								<div class="label">Entregas programadas</div>
							</div>
						</div>
					</div>

					<div class="col-12 col-md-5 d-flex" v-if="data.parkingOccupation">

						<div class="deposit fiscal">
							<h4>DEPÓSITO</h4>
							<h3>FISCAL</h3>
							<h2>{{data.parkingOccupation.fiscal.cars}}</h2>
						</div>
						<div class="deposit national">
							<h4>DEPÓSITO</h4>
							<h3>NACIONAL</h3>
							<h2>{{data.parkingOccupation.national.cars}}</h2>
						</div>

					</div>

				</div>

				<div class="row ">

					<div class="col col-12 ">
						<div class="bg-white">
							<b-tabs content-class=""  @activate-tab="activateTab">

								<b-tab title="Daños" active>
									<div class="p-4">
										<h4>Daños</h4>
										
										<table class="table" v-if="!loadingTab && damages.length>0">
											<tr class="table-head">
												<td></td>
												<td>Vehículo</td>
												<td>Chasis</td>
												<td>Cliente</td>
												<td>Responsabilidad</td>
											</tr>
											
											<router-link tag="tr" :to="`/cars/${item.car.id}`" v-for="item of damages" :key="item.id" >
												<td>
													<div class="tc">
														<span class="text-primary">{{item.typeText}}</span>
														<span >{{item.description}}</span>
													</div>
												</td>
												<td>
													<div class="tc">
														<span class="text-primary">{{item.car.brand.title}}</span>
														<span >{{item.car.model}}</span>
													</div>
												</td>
												<td>{{item.car.chassis_number}}</td>
												<td>
													<div class="tc">
														<span class="text-primary">{{item.car.client.name}}</span>
														<span >{{item.car.client.business_name}}</span>
													</div>
												</td>
												<td>
													<span v-if="item.responsible == 'INTERNAL'" >Interno</span>
													<span v-if="item.responsible == 'CLIENT'" >Cliente</span>
													<span v-if="item.responsible == 'THIRD'" >Tercero</span>
												</td>
											</router-link>
										</table>

										<div class="alert alert-light text-center mt-3" v-if="loadingTab">Cargando...</div>

										<div class="alert alert-light text-center" v-if="!loadingTab && damages.length==0">No se han encontrado daños</div>
									</div>
								</b-tab>

								<b-tab title="Cargos">
									<div class="p-4">
										<h4>Cargos</h4>
										<table class="table" v-if="!loadingTab && charges.length>0">
											<tr class="table-head">
												<td></td>
												<td>Chasis</td>
												<td>Vehículo</td>
												<td>Cliente</td>
											</tr>
											<router-link tag="tr" :to="`/cars/${item.car.id}`" v-for="item of charges" :key="item.id" >
												<td>
													<div class="tc">
														<span class="text-primary">{{item.description}}</span>
														<span >U$S {{item.price}}</span>
													</div>
												</td>
												<td>{{item.car.chassis_number}}</td>
												<td>
													<div class="tc">
														<span class="text-primary">{{item.car.brand.title}}</span>
														<span >{{item.car.model}}</span>
													</div>
												</td>
												<td>
													<div class="tc">
														<span class="text-primary">{{item.client.name}}</span>
														<span >{{item.client.business_name}}</span>
													</div>
												</td>
											</router-link>
										</table>
										<div class="alert alert-light text-center mt-3" v-if="loadingTab">Cargando...</div>
										<div class="alert alert-light text-center" v-if="!loadingTab && charges.length==0">No se han encontrado cargos</div>
									</div>
								</b-tab>
								
								<b-tab title="Entregas programadas">
									<div class="p-4">
										<h4>Entregas programadas </h4>
										<table class="table" v-if="!loadingTab && carsToDelivery.length>0">
											<tr class="table-head">
												<td>Chasis</td>
												<td>Vehículo</td>
												<td>Cliente</td>
												<td>Estado</td>
											</tr>
											
											<router-link tag="tr" :to="`/cars/${item.id}`" v-for="item of carsToDelivery" :key="item.id" >
												<td>{{item.chassis_number}}</td>
												<td>
													<div class="tc">
														<span class="text-primary">{{item.brand.title}}</span>
														<span >{{item.model}}</span>
													</div>
												</td>
												<td>
													<div class="tc">
														<span class="text-primary">{{item.client.name}}</span>
														<span >{{item.client.business_name}}</span>
													</div>
												</td>
												<td>
													<div class="tc">
														<span><div class="car-status-point" :class="item.status"></div>{{item.statusText}}</span>
														<span v-if="item.delivery_scheduled_at" style="margin-left: 15px;">{{item.delivery_scheduled_at | moment("DD-MM-YYYY")}}</span>
													</div>
												</td>
											</router-link>
										</table>
										
										<div class="alert alert-light text-center mt-3" v-if="loadingTab">Cargando...</div>
										<div class="alert alert-light text-center" v-if="!loadingTab && carsToDelivery.length==0">No se han encontrado entregas programadas</div>
									</div>
								</b-tab>
							</b-tabs>
						</div>

					</div>

				</div>
			</div>
		</div>

	</div>
</template>


<script>
import gql from 'graphql-tag'
// import { mapState } from 'vuex'
import Navbar from '@/components/Navbar'
import Loader from '@/components/Loader'

export default {
	name: 'dashboard',
	components: {
		Navbar,
		Loader
	},
	data(){
		return{
			data: null,
			loading: true,
			loadingTab: false,
			selectedClient:  null,
			damages: [],
			charges:[],
			carsToDelivery:[]
		}
	},
	beforeMount(){
		this.load();
		this.loadDamages()
	},
	methods:{
		carsListFiltered(status){
			let url = `/cars?status=${status}`
			if(this.$route.query.client_id){ url += `&client_id=${this.$route.query.client_id}` }
			this.$router.push(url)
		},
		load(){
			this.$apollo.query({
				query: gql`query  ($client_id: ID){
					userDashboard (client_id: $client_id) {
						totals{
							carsPreAdmited
							carsInCustomsDeposit
							carsCustomsDispatchPending
							carsCustomsDispatched
							carsInNationalDeposit
							carsPreDeliveryPending
							carsPreDeliveryDone
							carsDeliveryRequested
							carsDeliveryScheduled
						}
						parkingOccupation{
							fiscal
							national
						}
					}
					me{
						clients{
							id
							name
							business_name
						}
					}
				}`,
				variables: {
					client_id: this.$route.query.client_id,
				},
				fetchPolicy: 'no-cache'
			})
			.then((data) => {
				this.data = data.data.userDashboard;
				this.clients = data.data.me.clients;
				this.loading = false
				if(this.$route.query.client_id){
					this.clients.forEach(client => {
						if(client.id == this.$route.query.client_id) {this.selectedClient = client.name}
					})
				}
			});
		},
		filterByClient(client){
			if(client){
				this.$router.push({query:{client_id: client.id}})
			}else{
				this.$router.push({query:{}})
			}
		},
		activateTab(newTabIndex ){
			if(newTabIndex == 0){ this.loadDamages() }
			if(newTabIndex == 1){ this.loadCharges() }
			if(newTabIndex == 2){ this.loadCarsToDelivery() }
		},
		loadDamages(){
			this.loadingTab = true
			this.$apollo.query({
				query: gql`query ($first: Int!, $status: String, $client_id: ID){
					damages ( first: $first, status: $status, client_id: $client_id ){
						data{
							id
							typeText
							description
							responsible
							car{ id chassis_number brand{title} model client{ name business_name} }
						}
					}
				}`,
				fetchPolicy: 'no-cache',
				variables: {
					first: 10,
					status: 'ACTIVE',
					client_id: this.$route.query.client_id,
				},
			})
			.then((data) => {
				this.damages = data.data.damages.data;
				this.loadingTab = false
			});
		},
		loadCharges(){
			console.log('load charges')
			this.loadingTab = true
			this.$apollo.query({
				query: gql`query ($first: Int!, $status: String, $client_id: ID ){
					charges ( first: $first, status: $status, client_id: $client_id ){
						data{
							id
							description
							price
							car{ 
								id 
								chassis_number 
								model 
								brand{title} 
							}
							client{ name business_name} 
						}
					}
				}`,
				fetchPolicy: 'no-cache',
				variables: {
					first: 10,
					status: 'ACTIVE',
					client_id: this.$route.query.client_id
				},
			})
			.then((data) => {
				this.charges = data.data.charges.data;
				this.loadingTab = false
			});
		},
		loadCarsToDelivery(){
			console.log('loadCarsToDelivery')
			this.loadingTab = true
			this.$apollo.query({
				query: gql`query ($first: Int!, $status: String, $client_id: ID){
					cars ( first: $first, status: $status, client_id: $client_id ){
						data{
							id
							chassis_number 
							model 
							brand{title} 
							client{ name business_name}
							delivery_scheduled_at
							statusText
							status
						}
					}
				}`,
				fetchPolicy: 'no-cache',
				variables: {
					first: 10,
					status: 'DELIVERY_SCHEDULED',
					client_id: this.$route.query.client_id
				},
			})
			.then((data) => {
				this.carsToDelivery = data.data.cars.data;
				this.loadingTab = false
			});
		},
		
	}
}
</script>

<style scoped lang="scss">

.boxes{
	display: flex;
	width: 100%;
	flex-wrap: wrap;

	.box{
		margin: 2px;
		padding: 16px 8px;
		
		background-color: #fff;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		flex-grow: 1;
		cursor: pointer;
		transition: all .3s;

		.number{
			font-size: 1.6rem;
			font-weight: 600;;
		}
		.label{
			font-size: .7rem;
			font-weight: 400;
			text-align: center;
		}
	}
	.box:hover{
		background-color: #d7e7f5;
	}
}




.deposit{
    margin: 2px;
    padding: 16px 8px;
    color: #fff;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    flex-grow: 1;
    -webkit-transition: all .3s;
    transition: all .3s;
}

.deposit.fiscal{
	background-color:#46baca;
}
.deposit.national{
	background-color:#46ca4d;
}

.deposit h4{
	font-size: 12px;
    margin: 0px;
    font-weight: 600;
}
.deposit h3{
    margin: 0px;
    font-weight: 600;
}
.deposit h2{
	font-size: 32px;
    margin: 0px;
    font-weight: 600;
}
</style>
